import { storage } from "../firebaseConfig";
import { ref, getDownloadURL, listAll, uploadBytes } from "firebase/storage";

export class StorageController {
  static IMAGE_PATH = "images/dokokoko/cafe";

  static addAll = ({ folderName, files, resolve, reject }) => {
    let errorMessage =
      "Unable to upload all the images.\nPlease contact administrator for assistance.";
    const uploadPromises = Array.from(files).map((file) => {
      const storageRef = ref(
        storage,
        `${this.IMAGE_PATH}/${folderName}/${file?.name}`
      );
      return uploadBytes(storageRef, file)
        .then(() => {
          console.debug(`${file?.name} uploaded successfully.`);
          return getDownloadURL(storageRef);
        })
        .catch((error) => {
          console.debug(error.message);
          throw new Error(errorMessage);
        });
    });
    Promise.all(uploadPromises)
      .then((urls) => {
        resolve(urls);
      })
      .catch((error) => {
        console.debug(error.message);
        reject(errorMessage);
      });
  };

  static add = ({ tableName = null, file, resolve, reject }) => {
    let errorMessage =
      "Unable to upload all the images.\nPlease contact administrator for assistance.";
    const storageRef = ref(
      storage,
      tableName
        ? `${this.IMAGE_PATH}/${tableName}/${file?.name}`
        : `${this.IMAGE_PATH}/${file?.name}`
    );
    uploadBytes(storageRef, file)
      .then(() => {
        console.debug(`${file?.name} uploaded successfully.`);
        return getDownloadURL(storageRef);
      })
      .then((url) => {
        console.debug(url);
        resolve({ default: url });
      })
      .catch((error) => {
        console.debug(error.message);
        reject(errorMessage);
      });
  };
}

// export const listAllImages = ({ folderName, resolve, reject }) => {
//   let errorMessage =
//     "Unable to get all images from firebase.\nPlease contact administrator for assistance.";
//   const imgRef = ref(storage, `images/${folderName}`);
//   listAll(imgRef)
//     .then((data) => {
//       const urlPromises = data.items.map((imageRef) =>
//         getDownloadURL(imageRef)
//       );
//       Promise.all(urlPromises)
//         .then((data) => {
//           console.debug(data);
//           resolve(data);
//         })
//         .catch((error) => {
//           console.debug(error.message);
//           reject(errorMessage);
//         });
//     })
//     .catch((error) => {
//       console.debug(error.message);
//       reject(errorMessage);
//     });
// };
